import { GET_CONTAB_CENTRO, MODIFY_CONTAB_CENTRO, ADD_CONTAB_CENTRO, REMOVE_CONTAB_CENTRO } from '../constants/action_types';

const initialState = { contabCentro: [], isLoading: true };

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_CONTAB_CENTRO + "_SUCCESS":

            return {
                contabCentro: action.payload.data,
                isLoading: false
            };

        case MODIFY_CONTAB_CENTRO:

            return {
                contabCentro: state.contabCentro.map((caja) => {
                    if (caja.id !== action.payload.id) return caja;
                    else return action.payload;
                }),
                isLoading: false
            };

        case ADD_CONTAB_CENTRO:
            const newArr = [...state.contabCentro, action.payload]

            return {
                contabCentro: newArr,
                isLoading: false
            };

        case REMOVE_CONTAB_CENTRO:

            return {
                contabCentro: state.contabCentro.filter(caja => caja.id !== action.payload.id),
                isLoading: false
            };

        default:

            return state;
    }
}